import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UploadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Upload",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.63 16.69c.37-.48.59-1.08.59-1.74v-.03c0-1.68-1.37-3.05-3.05-3.05h-.18c-.68.03-1.29.29-1.77.7a6.747 6.747 0 0 0-13.43.95v.13c0 .42.05.83.13 1.23v-.04h-.77c-.42 0-.83.06-1.23.16h.03c-2.29.56-3.97 2.6-3.97 5.03s1.67 4.47 3.93 5.03h.04c.36.1.77.16 1.19.16h7.05v-5.66h-2.67a.87.87 0 0 1-.57-1.53s3.92-3.92 3.92-3.92c.16-.16.38-.26.62-.26s.46.1.62.26l3.92 3.92a.87.87 0 0 1-.57 1.53h-2.67v5.67h9.05c2.29-.08 4.12-1.95 4.12-4.26s-1.91-4.26-4.26-4.26h-.14l.03-.02Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.43 30.57c-.63 0-1.14-.51-1.14-1.14v-8a1.14 1.14 0 1 1 2.28 0v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21 27.14c-.29 0-.58-.11-.81-.33l-3.76-3.76-3.76 3.76c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l4.57-4.57c.43-.43 1.19-.43 1.62 0l4.57 4.57a1.14 1.14 0 0 1-.81 1.95M23.29 18H9.58c-3.15 0-5.71-2.56-5.71-5.71s2.56-5.71 5.71-5.71c2.03 0 3.93 1.09 4.95 2.86.32.55.13 1.25-.42 1.56-.55.32-1.25.13-1.56-.42a3.43 3.43 0 1 0-2.97 5.15h13.71c1.89 0 3.43-1.54 3.43-3.43s-1.54-3.43-3.43-3.43a1.14 1.14 0 1 1 0-2.28c3.15 0 5.71 2.56 5.71 5.71s-2.56 5.71-5.71 5.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.29 8.86c-.63 0-1.14-.51-1.14-1.14 0-2.52-2.05-4.57-4.57-4.57-1.45 0-2.78.67-3.66 1.83-.38.5-1.09.61-1.6.23-.5-.38-.61-1.1-.23-1.6A6.82 6.82 0 0 1 17.58.87c3.78 0 6.86 3.08 6.86 6.86 0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};